import * as signalR from '@microsoft/signalr'

function getCsrfHeader(): Record<string, string> {
	// Temporary local testing against dev: paste the XSRF-TOKEN-DEV cookie value.
	const localCsrfToken =
		'C94FE1AA3673F76F46315282000919EAE8613FD14D9A18547757D98DB17E277A'
	const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(
		window.location.hostname,
	)
	if (isLocalhost && localCsrfToken.trim()) {
		return { 'X-XSRF-TOKEN-DEV': localCsrfToken.trim() }
	}

	const match = document.cookie.match(/(?:^|;\s*)(XSRF-TOKEN[\w-]*)=([^;]+)/)
	if (!match) return {}
	const [, cookieName, cookieValue] = match
	return { [`X-${cookieName}`]: decodeURIComponent(cookieValue) }
}

class SignalRApi {
	private static connection: signalR.HubConnection | null = null

	static async createConnection(): Promise<signalR.HubConnection> {
		if (this.connection) return this.connection

		try {
			this.connection = new signalR.HubConnectionBuilder()
				.withUrl(`${process.env.REACT_APP_BACKEND_API}/hubs/main`, {
					withCredentials: true,
					headers: getCsrfHeader(),
				})
				.withAutomaticReconnect()
				.configureLogging(signalR.LogLevel.Information)
				.build()

			await this.connection.start()
			console.log('Connected to SignalR')

			return this.connection
		} catch (error) {
			console.error('SignalR connection failed:', error)
			throw error
		}
	}

	static disconnect(): void {
		if (this.connection) {
			this.connection.stop()
			this.connection = null
		}
	}
}

export default SignalRApi
